/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useMemo } from "react";
import { RouterProvider } from "react-router-dom";
import Router from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ConfigProvider, theme } from "antd";
import "./styles/style.scss";
import "./styles/table.scss";
import NotificationInterceptor from "./NotificationInterceptor";
import { DownloadProvider } from "./context/global/DownloadProvider";
import { useInfoUser } from "./store/UserStore";
import dayjs from "dayjs";

import enUS from "antd/locale/en_US";
import viVN from "antd/locale/vi_VN";
import koKR from "antd/locale/ko_KR"; // Thêm tiếng Hàn

import "dayjs/locale/vi";
import "dayjs/locale/ko";
import { SendingProvider } from "./context/global/SendingProvider";

function App() {
  const { user } = useInfoUser();

  const currentLang = user?.language;

  useEffect(() => {
    switch (currentLang) {
      case "vn":
        dayjs.locale("vi");
        break;
      case "kr":
        dayjs.locale("ko");
        break;
      default:
        dayjs.locale("en");
        break;
    }
  }, [currentLang]);

  const antdLocale = useMemo(() => {
    switch (currentLang) {
      case "vn":
        return viVN;
      case "kr":
        return koKR;
      default:
        return enUS;
    }
  }, [currentLang]);

  return (
    <ConfigProvider theme={theme} locale={antdLocale}>
      <DownloadProvider>
        <SendingProvider>
          <NotificationInterceptor />
          <RouterProvider router={Router} />
          <ToastContainer autoClose={1500} />
        </SendingProvider>
      </DownloadProvider>
    </ConfigProvider>
  );
}

export default App;
